<div class="composer-area">
  <!-- <div class="prompt-row" aria-label="Quick prompts">
    @for (keyword of keywords(); track keyword) {
      <button type="button" (click)="selectKeyword(keyword)">{{ keyword }} <span>↗</span></button>
    }
  </div> -->
  <div
    class="composer-drop"
    [class.drag-over]="isDragOver()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)"
  >
    @if (pendingAttachments().length) {
    <div class="attachment-strip" aria-label="Attached files">
      @for (attachment of pendingAttachments(); track attachment.id) {
      <figure class="attachment-chip">
        @if (attachment.dataUrl) {
        <img [src]="attachment.dataUrl" [alt]="attachment.name" />
        } @else {
        <span class="attachment-file" aria-hidden="true">📎</span>
        }
        <figcaption class="attachment-name">{{ attachment.name }}</figcaption>
        <button type="button" class="attachment-remove" (click)="removeAttachment(attachment.id)" [attr.aria-label]="'Remove ' + attachment.name">&times;</button>
      </figure>
      }
    </div>
    }
    <form class="composer" (ngSubmit)="submitMessage()">
      <input
        name="message"
        type="text"
        placeholder="Write a message..."
        autocomplete="off"
        [ngModel]="draft()"
        (ngModelChange)="setDraft($event)"
        (keydown.enter)="onEnterKey($event)"
        (paste)="onPaste($event)"
        aria-label="Message"
      />
      <button type="button" class="attach-button" (click)="openFileDialog()" [disabled]="isThinking()" aria-label="Attach a file or image" title="Attach a file or image">
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21.44 11.05l-9.19 9.19a5 5 0 0 1-7.07-7.07l9.19-9.19a3.5 3.5 0 0 1 4.95 4.95l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
        </svg>
      </button>
      <input #fileInput type="file" [attr.accept]="acceptedTypes" multiple hidden (change)="onFileChange($event)" aria-hidden="true" tabindex="-1" />
      <app-option-picker
        [options]="modelOptions()"
        [selectedValue]="model()"
        [placeholder]="'Model'"
        [ariaLabel]="'Chat model'"
        (valueChange)="modelChange.emit($event)"
      />
      <app-option-picker
        [options]="thinkingOptions"
        [selectedValue]="thinkingMode()"
        [ariaLabel]="'Thinking mode'"
        (valueChange)="thinkingModeChange.emit($event)"
      />
      <button
        class="send-button"
        type="button"
        [class.stop]="isThinking()"
        (click)="toggleSubmit()"
        [attr.aria-label]="isThinking() ? 'Stop generating' : 'Send message'"
      >
        @if (isThinking()) {
        <span class="stop-icon" aria-hidden="true"></span>
        } @else {
        <span aria-hidden="true">↑</span>
        }
      </button>
    </form>
  </div>
  <p class="composer-note">Serg can make mistakes. Check important details.</p>
</div>
